var _path, _rect, _rect2, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path5, _path6, _path7, _mask, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgNoSigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 195,
    viewBox: "0 0 261 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.5 184C234.809 184 261 179.747 261 174.5C261 169.253 234.809 165 202.5 165C170.191 165 144 169.253 144 174.5V174.5C144 177.116 144.798 183.675 142.342 184.575C139.577 185.587 138 186.756 138 188C138 191.866 153.222 195 172 195C190.778 195 206 191.866 206 188C206 186.865 204.687 185.793 202.357 184.844C201.962 184.683 202.073 184 202.5 184V184Z",
    fill: "#F8F8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.0126,
    y: 92.2899,
    width: 242.361,
    height: 6.42017,
    fill: "#D8D8D9",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.0126,
    y: 155.689,
    width: 242.361,
    height: 6.42017,
    fill: "#D8D8D9",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8992 181.87H69.5168V188.191C69.5168 189.466 68.4831 190.5 67.208 190.5C65.9329 190.5 64.8992 189.466 64.8992 188.191V181.87Z",
    fill: "white",
    stroke: "#D8D8D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.227 181.87H173.845V188.191C173.845 189.466 172.811 190.5 171.536 190.5C170.261 190.5 169.227 189.466 169.227 188.191V181.87Z",
    fill: "white",
    stroke: "#D8D8D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.335 65.3595L242.059 65.4977V65.8067V174.95V175.45H242.559H252.189H252.689V174.95V65.8067V65.4977L252.413 65.3595L247.598 62.952L247.374 62.8402L247.15 62.952L242.335 65.3595Z",
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 233.231,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5294,
    y: 72.7269,
    width: 5.42017,
    height: 100.118,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 222.798,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64.0966,
    y: 72.7269,
    width: 5.42017,
    height: 100.118,
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.366,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6639,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 201.933,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2311,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 191.5,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7983,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 181.067,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3655,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 171.634,
    y: 72.7269,
    width: 5.42017,
    height: 100.118,
    stroke: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9328,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 161.202,
    y: 72.7269,
    width: 5.42017,
    height: 100.118,
    stroke: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 60.084,
    y: 0.5,
    width: 118.576,
    height: 182.777,
    rx: 4.5,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 71.7269,
    width: 7.42017,
    height: 102.118,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 184.277,
    y: 89.3823,
    width: 32.2983,
    height: 22.6681,
    fill: "white",
    stroke: "#D8D8D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 189.592,
    y: 94.6975,
    width: 23.2731,
    height: 2.40756,
    fill: "#F8F8F8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 65.2017,
    y: 6.42017,
    width: 106.735,
    height: 92.2899,
    rx: 2,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6092,
    y: 105.933,
    width: 6.42017,
    height: 42.5336,
    fill: "#D8D8D9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4496,
    y: 109.143,
    width: 36.916,
    height: 2.40756,
    fill: "#F8F8F8"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4496,
    y: 126.798,
    width: 24.0756,
    height: 2.40756,
    fill: "#F8F8F8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4496,
    y: 113.958,
    width: 28.8908,
    height: 2.40756,
    fill: "#F8F8F8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4496,
    y: 131.613,
    width: 18.458,
    height: 2.40756,
    fill: "#F8F8F8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4496,
    y: 139.639,
    width: 18.458,
    height: 2.40756,
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.42 171.166C167.208 172.287 166.942 173.871 165.657 174.348C164.515 174.772 163.296 174.978 162.063 174.946C159.996 174.894 158.002 174.178 156.374 172.905C154.745 171.631 153.57 169.868 153.022 167.875C152.473 165.882 152.58 163.766 153.328 161.838C154.075 159.911 155.422 158.275 157.171 157.173C158.919 156.071 160.976 155.56 163.037 155.717C165.098 155.874 167.054 156.689 168.616 158.043C169.547 158.851 170.309 159.825 170.867 160.909C171.495 162.127 170.624 163.476 169.286 163.773V163.773C167.948 164.069 166.656 163.142 165.722 162.139C165.609 162.018 165.49 161.903 165.364 161.794C164.607 161.137 163.659 160.742 162.661 160.666C161.662 160.59 160.665 160.838 159.818 161.372C158.971 161.906 158.318 162.699 157.956 163.633C157.594 164.566 157.542 165.592 157.807 166.558C158.073 167.523 158.643 168.378 159.432 168.995C160.221 169.612 161.187 169.959 162.188 169.984C162.355 169.989 162.521 169.984 162.685 169.97C164.052 169.859 165.631 170.045 166.42 171.166V171.166Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.384 105.474C197.647 105.848 197.558 106.376 197.129 106.535C196.749 106.676 196.342 106.745 195.931 106.734C195.242 106.717 194.578 106.478 194.035 106.054C193.492 105.629 193.1 105.041 192.918 104.377C192.735 103.713 192.771 103.007 193.02 102.365C193.269 101.723 193.718 101.177 194.301 100.81C194.883 100.442 195.569 100.272 196.256 100.324C196.943 100.377 197.595 100.649 198.116 101.1C198.426 101.369 198.68 101.694 198.866 102.055C199.075 102.461 198.785 102.911 198.339 103.01V103.01C197.893 103.109 197.462 102.799 197.151 102.465C197.113 102.425 197.074 102.386 197.032 102.35C196.779 102.131 196.463 102 196.131 101.974C195.798 101.949 195.465 102.031 195.183 102.209C194.901 102.388 194.683 102.652 194.562 102.963C194.442 103.274 194.424 103.616 194.513 103.938C194.601 104.26 194.791 104.545 195.054 104.75C195.317 104.956 195.639 105.072 195.973 105.08C196.029 105.082 196.084 105.08 196.139 105.076C196.594 105.039 197.121 105.1 197.384 105.474V105.474Z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.254 101.747C202.95 101.406 202.415 101.373 202.163 101.754C201.939 102.092 201.78 102.473 201.697 102.875C201.557 103.55 201.639 104.252 201.929 104.877C202.219 105.502 202.702 106.017 203.307 106.346C203.913 106.675 204.608 106.8 205.29 106.704C205.972 106.607 206.605 106.294 207.096 105.809C207.586 105.325 207.908 104.696 208.013 104.015C208.118 103.335 208.001 102.638 207.68 102.028C207.488 101.665 207.23 101.344 206.921 101.08C206.573 100.784 206.069 100.965 205.871 101.377V101.377C205.673 101.789 205.877 102.278 206.131 102.658C206.162 102.703 206.191 102.751 206.216 102.8C206.372 103.095 206.429 103.433 206.378 103.763C206.327 104.093 206.171 104.398 205.933 104.632C205.696 104.867 205.389 105.019 205.058 105.065C204.728 105.112 204.391 105.051 204.098 104.892C203.804 104.732 203.57 104.483 203.429 104.18C203.289 103.877 203.249 103.537 203.317 103.21C203.328 103.156 203.342 103.102 203.359 103.05C203.499 102.615 203.558 102.088 203.254 101.747V101.747Z",
    fill: "#F8F8F8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 10,
    width: 103,
    height: 89
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 10,
    width: 103,
    height: 89,
    rx: 5,
    fill: "#F8F8F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.671 84.0137H161.111V39.4238H106.925V64.4986H106.365V38.863H161.671V84.0137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.728 84.2329H161.16V38.8342H163.094L178.747 20.2329L193.744 39.0263V55.8347H193.185V39.2184L178.747 21.1294L163.35 39.3945H161.719V83.6726H193.169L193.185 62.2859H193.744L193.728 84.2329Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.082 39.4475H193.394L178.803 21.1732L163.395 39.4475H104.964L102.42 37.6377L120.836 18.1141H146.115V18.6747H121.076L103.268 37.5576L105.14 38.8869H163.139L178.803 20.2763L193.666 38.8869H194.914L178.707 18.6747H155.827V18.1141H178.979L179.059 18.2262L196.082 39.4475Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.046 87.8858H134.201V83.7214H140.046V87.8858ZM134.763 87.3295H139.484V84.2777H134.763V87.3295Z",
    fill: "#D4EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.037 87.8858H161.16V83.7214H194.021V87.8858H194.037ZM161.719 87.3295H193.461V84.2777H161.719V87.3295Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.749 87.8858H170.731V83.7214L173.22 83.7373V85.7242H174.733L174.749 87.8858ZM171.282 87.3295H174.197V86.2646H172.685V84.2777H171.298V87.3295H171.282Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.274 62.5343H161.16V55.8859H198.274V62.5343ZM161.72 61.9815H197.714V56.4386H161.72V61.9815Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.712 62.6804H161.16V55.8859H166.712V62.6804ZM161.718 62.1169H166.154V56.4494H161.718V62.1169Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.671 58.516H113.16V46.7534H129.671V58.516ZM113.721 57.9551H129.11V47.3303H113.721V57.9551Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.804 58.516H138.292V46.7534H154.804V58.516ZM138.853 57.9551H154.243V47.3303H138.853V57.9551V57.9551Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.511 87.8859H139.461V64.1416H154.495V87.8859H154.511ZM140.02 87.3248H153.937V64.7027H140.02V87.3248Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.105 89.8584H134.201V87.3744H165.105V89.8584ZM134.76 89.2975H164.546V87.9353H134.76V89.2975Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.251 89.8584H164.594V87.3744H197.251V89.8584V89.8584ZM165.153 89.2864H196.692V87.9464H165.153V89.2864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.785 84.2328H116.667V65.6027H134.785V84.2328ZM117.229 83.6736H134.223V66.1619H117.229V83.6736Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.251 89.8584H94.4566V65.6027H117.251V89.8584ZM95.0153 89.2976H116.692V66.1634H95.0153V89.2976Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.785 87.8858H116.667V83.7214H134.785V87.8858ZM117.229 87.3295H134.223V84.2777H117.229V87.3295Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.785 89.8584H116.667V87.3744H134.785V89.8584ZM117.229 89.2975H134.223V87.9353H117.229V89.2975Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3584 87.8858H94.4566V83.7214H97.7443V84.2777H94.9969V87.3295H97.3584V87.8858Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.251 87.8858H113.306V87.3295H116.688V84.2777H113.306V83.7214H117.251V87.8858Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.251 89.8584H94.4566V87.3744H97.8543V87.9353H95.0149V89.2975H116.693V87.6629H117.251V89.8584Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.785 66.1873H117.689V64.1416H134.785V66.1873ZM118.251 65.6004H134.224V64.7285H118.251V65.6004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.274 66.1873H93.653V64.1416H118.274V66.1873ZM94.2133 65.6004H117.714V64.7285H94.2133V65.6004Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.836 32.1415H145.744V14.7534H149.836V32.1415ZM146.317 31.5812H149.263V15.3138H146.317V31.5812Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.762 32.1415H149.251V14.7854L156.046 14.7534V24.4703L149.762 32.1415ZM149.809 15.3447V31.1986L155.487 24.2626V15.3128L149.809 15.3447Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.039 15.2648H145.525V13H150.055V15.2648H150.039ZM146.083 14.7105H149.497V13.5543H146.083V14.7105Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.265 15.2648H149.397V13H156.265V15.2648ZM149.964 14.7105H155.698V13.5543H149.964V14.7105Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.671 89.7123H97.6712V76.1233H113.671V89.7123ZM98.2513 89.1541H113.123V76.6815H98.2513V89.1541V89.1541Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.498 75.5388H119.954V70.7169H131.498V75.5388ZM120.516 74.9818H130.936V71.2739H120.516V74.9818V74.9818Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.639 37.8402H102.785V37.2801H162.383L178.554 18.1873L178.986 18.5553L162.639 37.8402Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 76.4155H105.342V89.4932H106V76.4155Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.635 80.3607H98.0365V80.8721H105.635V80.3607Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.635 85.1096H98.0365V85.6941H105.635V85.1096Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.708 47.1187H121.123V58.2967H121.708V47.1187Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.306 52.452H113.306V53.0365H129.306V52.452Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.986 47.1187H146.402V58.2967H146.986V47.1187Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.584 52.452H138.584V53.0365H154.584V52.452Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.279 64.5068H146.694V87.5936H147.279V64.5068Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.292 71.009H139.68V71.5935H154.292V71.009Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3288 81.6028H71.0046V82.1873H82.3288V81.6028Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3288 82.991H71.0046V83.5024H82.3288V82.991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3288 84.3059H71.0046V84.8904H82.3288V84.3059Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0091 85.9863H69.6164V86.5708H84.0091V85.9863Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1963 80.7991H72.6849V89.347H73.1963V80.7991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7944 80.7991H80.21V89.347H80.7944V80.7991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9808 69.1096C90.0289 69.3942 89.9808 69.6314 89.9005 69.8528C89.8202 70.0742 89.6917 70.2639 89.5311 70.4379C89.3706 70.6118 89.1939 70.7541 88.9852 70.849C88.7764 70.9439 88.5356 71.023 88.2466 71.0071C88.2947 70.7225 88.3911 70.5169 88.5035 70.3272C88.6159 70.1374 88.7283 69.9793 88.8728 69.8212C89.0173 69.6789 89.1618 69.5366 89.3385 69.4101C89.5151 69.3152 89.7078 69.2045 89.9808 69.1096Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0567 68.8904C87.2953 69.0351 87.4444 69.2281 87.5637 69.4211C87.683 69.6302 87.7427 69.8553 87.7874 70.0805C87.8173 70.3056 87.8173 70.5469 87.7725 70.772C87.7278 70.9972 87.6383 71.2384 87.4593 71.4475C87.2804 71.2223 87.1909 71.0132 87.1163 70.8202C87.0417 70.6112 86.997 70.4182 86.9672 70.2091C86.9374 70.0001 86.9224 69.8071 86.9374 69.5819C86.9224 69.3889 86.9672 69.1638 87.0567 68.8904Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7626 72.105H85.1781V89.4931H85.7626V72.105Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3119 75.2874L85.227 79.434L85.7274 79.6856L87.8123 75.539L87.3119 75.2874Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4338 80.4338C81.6213 80.4338 78.5297 77.3426 78.5297 73.5308C78.5297 71.5608 79.8432 66.6919 81.1568 62.9121C82.4062 59.2764 84.1683 54.936 85.4338 54.936C86.6993 54.936 88.4614 59.2764 89.7108 62.9121C91.0083 66.6919 92.3379 71.5608 92.3379 73.5308C92.3219 77.3426 89.2303 80.4338 85.4338 80.4338ZM85.4338 55.4966C84.9853 55.4966 83.6077 57.5146 81.6854 63.1043C80.1796 67.4607 79.0903 71.8651 79.0903 73.5468C79.0903 77.0383 81.9417 79.8892 85.4338 79.8892C88.9259 79.8892 91.7772 77.0383 91.7772 73.5468C91.7772 71.8651 90.688 67.4607 89.1822 63.1043C87.2599 57.5146 85.8823 55.4966 85.4338 55.4966Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 89.2739H58V89.8584H234V89.2739Z",
    fill: "#E6E6E6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSigns);
export default __webpack_public_path__ + "static/media/no-signs.94e929080eb54285a5c57420a3ccbc2f.svg";
export { ForwardRef as ReactComponent };